import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';
import * as OT from '@opentok/client';
import {Router} from '@angular/router';

@Component({
  selector: 'app-publisher',
  templateUrl: './publisher.component.html',
  styleUrls: ['./publisher.component.css']
})

export class PublisherComponent implements AfterViewInit {
  @ViewChild('publisherDiv') publisherDiv: ElementRef;
  @Input() session: OT.Session;
  publisher: OT.Publisher;
  publishing: Boolean;
  openTok;
  messageErreur: string;
  TITRE_POPIN = 'Erreur lors de la publication';
  PAGE_DOSSIER = '/dossier';
  referenceSinistre = localStorage.getItem('refSinistre');

  constructor(private router: Router) {
    this.publishing = false;
    this.openTok = OT;
  }

  ngAfterViewInit() {

    let properties = {};

      properties = {
        width: '100%',
        height: '100%',
        fitMode: 'contain',
        mirror: false,
        facingMode: 'user'
      };

    this.publisher = this.openTok.initPublisher(this.publisherDiv.nativeElement, properties);

    if (this.session) {
      if (this.session['isConnected']()) {
        this.publish();
      }
      this.session.on('sessionConnected', () => this.publish());
    }
  }

  publish() {
    this.session.publish(this.publisher,
      (err) => {
        if (err) {
          this.messageErreur = err.message;
        } else {
          this.publishing = true;
        }
      });
  }

  raccrocher() {
    if (this.session) {
      this.session.unpublish(this.publisher);
      this.publisher.destroy();
      this.session.disconnect();
      this.router.navigate(['/dossier']);
    }
  }

  onChangeCamera() {
    this.publisher.cycleVideo();
  }

  detectIphone(): boolean {
    return !(navigator.userAgent.search(/(?:iPhone|iPad)/) === -1);

  }
}



// WEBPACK FOOTER //
// ./src/app/visio/publisher/publisher.component.ts